module.exports = __webpack_public_path__ + "img/funGoDetailDataNew.7f18c25e.png";